export default [
  {
    path: "/instructor-dashboard",
    name: "instructor-main",
    component: () => import("../../modules/Instructor/InstructorView.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["instructor"],
    },
  },
  {
    path: "/instructor-groups",
    name: "instructor-groups",
    component: () =>
      import(
        "../../modules/Instructor/pages/InstructorGroups/InstructorGroups.vue"
      ),
    meta: {
      layout: "main",
      auth: true,
      role: ["instructor"],
    },
  },
];
